<template>
    <div class="accent-box d-flex flex-column" :class="{'accent-box-hidden': !showBox}">
        <div v-if="showBox" class="accent-box-title">
            <!--You can add a simple title with the title prop, or use whatever content you want with the title slot.-->
            <slot name="title">
                <h4 class="text-dark">{{title}}</h4>
            </slot>
        </div>
        <div v-if="showBody" class="accent-box-body flex-grow-1">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccentBox',
    props: {
        title: {
            type: String,
            required: false
        },
        //This prop allows you to conditionally hide the accent-box-body while still showing the title.
        showBody: {
            type: Boolean,
            required: false,
            default: true
        },
        //This prop allows you to conditionally hide the title and box while still showing the body content.
        showBox: {
            type: Boolean,
            required: false,
            default: true
        }
    }
};
</script>

<style lang="scss" scoped>
.accent-box:not(.accent-box-hidden) {
    .accent-box-body {
        background: $white;
        padding: 1rem;
        border: $secondary solid 2px;
        border-radius: $inset-section-border-radius;
    }

    &.smaller {
        .accent-box-title {
            font-size: 1.25rem;
        }
    }
}

@include media-breakpoint-down(lg) {
    .accent-box:not(.accent-box-hidden) {
        .accent-box-title {
            font-size: 1.25rem;
        }
    }
}

@include media-breakpoint-down(sm) {
    .accent-box:not(.accent-box-hidden) {
        &.smaller {
            .accent-box-title {
                font-size: 1rem;
            }
        }
    }
}
</style>